import React, { Component } from 'react';
import styled from 'styled-components';
import Clipboard from 'react-clipboard.js';
import propTypes from 'prop-types';

const StyledClipboard = styled(Clipboard)`
  border-radius: 3px;
  background: azure;
  color: #555555;
  padding: 9px 10px 8px;
  border: solid 1px rgb(216, 216, 216);
  cursor: pointer;
`;

const ClipboardLabel = styled.div`
  border-radius: 3px;
  background: azure;
  color: #1ba597;
  padding: 9px 10px 8px;
`;

class ClipboardButton extends Component {
  state = {
    copied: false
  };

  timer = null;

  onCopy = () => {
    const { copyWithAlert } = this.props;

    this.setState({
      copied: true
    });
    clearTimeout(this.timer);
    this.timer = setTimeout(() => this.setState({ copied: false }), 1500);
    copyWithAlert && copyWithAlert();
  };

  render() {
    const { text, copyWithAlert } = this.props;
    const { copied } = this.state;

    if (copied && !copyWithAlert) {
      return <ClipboardLabel>Has been copied to the clipboard</ClipboardLabel>;
    }
    return (
      <StyledClipboard data-clipboard-text={text} onClick={this.onCopy}>
        {this.props.children ? this.props.children : 'Copy link for nomination'}
      </StyledClipboard>
    );
  }
}

ClipboardButton.propTypes = {
  children: propTypes.node,
  text: propTypes.string,
  copyWithAlert: propTypes.func
};

export default ClipboardButton;
